import React, { useState } from "react";
import { EyeInvisibleOutlined, EyeOutlined, LoadingOutlined, LockOutlined, MailOutlined } from "@ant-design/icons";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import adminApi from "../api/adminApi";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  if (adminApi.getAccessToken()) return <Navigate to="/admin" replace />;

  async function submit(event) {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      await adminApi.login(email.trim(), password);
      navigate(location.state?.from?.pathname || "/admin", { replace: true });
    } catch (err) {
      setError(adminApi.getErrorMessage(err, "Login failed. Check your credentials."));
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="admin-login">
      <section className="admin-login-story">
        <div className="admin-login-brand"><img src="/images/CompanyLogo.png" alt="Sun Pledge" /><span>Sun Pledge</span></div>
        <div><span className="admin-eyebrow">Solar portfolio management</span><h1>Powering a cleaner tomorrow, one project at a time.</h1><p>Securely manage installations, project imagery, and portfolio categories from a single workspace.</p></div>
        <small>Sun Pledge (Pvt) Ltd · Administrative access only</small>
      </section>
      <section className="admin-login-form-wrap">
        <form className="admin-login-card" onSubmit={submit}>
          <div className="admin-login-mark"><LockOutlined /></div>
          <span className="admin-eyebrow">Welcome back</span><h2>Sign in to your account</h2><p>Enter your administrator credentials to continue.</p>
          {location.state?.expired && <div className="admin-alert warning">Your session expired. Please sign in again.</div>}
          {error && <div className="admin-alert error">{error}</div>}
          <label className="admin-login-field"><span>Email address</span><div><MailOutlined /><input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email address" required autoFocus /></div></label>
          <label className="admin-login-field"><span>Password</span><div><LockOutlined /><input type={visible ? "text" : "password"} autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" required /><button type="button" onClick={() => setVisible((value) => !value)} aria-label={visible ? "Hide password" : "Show password"}>{visible ? <EyeInvisibleOutlined /> : <EyeOutlined />}</button></div></label>
          <button className="admin-login-submit" disabled={loading}>{loading ? <><LoadingOutlined spin /> Signing in…</> : "Sign in securely"}</button>
          <small className="admin-login-help">Having trouble signing in? Contact your system administrator.</small>
        </form>
      </section>
    </main>
  );
}
